module.exports = __webpack_public_path__ + "img/b5.9f98966b.png";